import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "Settings";

const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function useSettingsState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `useAuthState must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export function useSettingsDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `useSettingsState must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export const SettingsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
